import 'raf/polyfill';
import 'element-closest';

// Polyfill custom event for IE9,10,11
import 'custom-event-polyfill';

import cssVars from 'css-vars-ponyfill';

// Used for IE11 CSS var compatability
cssVars({
  watch: true,
});
